/* eslint-disable react/destructuring-assignment */
import * as React from "react";

const BellIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} fill="none" {...props}>
    <path
      fill={props.color || "#334155"}
      d="M14.363 10.996C14.016 10.4 13.5 8.708 13.5 6.5a5 5 0 0 0-10 0c0 2.209-.516 3.899-.863 4.496A1 1 0 0 0 3.5 12.5h2.55a2.5 2.5 0 0 0 4.9 0h2.55a1 1 0 0 0 .863-1.504ZM8.5 13.5a1.5 1.5 0 0 1-1.413-1h2.827a1.5 1.5 0 0 1-1.414 1Zm-5-2c.482-.828 1-2.745 1-5a4 4 0 0 1 8 0c0 2.253.518 4.17 1 5h-10Z"
    />
  </svg>
);

export default BellIcon;
